<template>
  <div class="enablebanking-home loading-content">
    <div class="enablebanking-status text-center">
      <Spinner v-if="loading" class="enablebanking-status-spinner mx-auto" />
      <div class="enablebanking-status-info text-dark">{{ message }}</div>
      <div class="enablebanking-status-error text-danger">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import Spinner from '../components/elements/Spinner.vue'
import BaseService from '../services/BaseService.js'
import { sendUrlToOpenedTab } from '../services/newTabChannel.js'
export default {
  name: 'Home',
  components: {
    Spinner
  },
  data () {
    return {
      loading: true,
      message: '',
      error: ''
    }
  },
  async mounted () {
    // Another tab may take this URL over and close this tab, so nothing else
    // may run until the handover has been ruled out.
    const handedOver = window.history.length === 1 && await sendUrlToOpenedTab(() => { window.close() })
    if (handedOver) {
      return
    }
    try {
      const r = await BaseService.getNextPage()
      const redirectUrl = r.data.redirect_url
      if (redirectUrl) {
        // Redirect to the next page without leaving a history entry for this page.
        window.location.replace(redirectUrl)
      }
    } catch (e) {
      this.error = this.$t('Authentication session has expired')
      this.loading = false
    }
  }
}
</script>

<style>
.loading-content {
  padding-top: 20vh;
}
</style>
